<template>
    <div class="m-about">
        <section class="m-about-hero">
            <img class="m-about-hero__bg"
                src="https://qiniu.shunmingelectronic.com/guanwang/product/%E5%85%B3%E4%BA%8E%E6%88%91%E4%BB%AC.png"
                alt="关于我们" />
            <div class="m-about-hero__overlay"></div>
            <div class="m-about-hero__content">
                <span class="km-eyebrow">ABOUT US</span>
                <h1 class="m-about-hero__title">关于我们</h1>
            </div>
        </section>

        <section class="m-section">
            <div class="km-container">
                <div class="m-head">
                    <span class="km-eyebrow">关于舜铭</span>
                    <h2 class="m-h2">以创新驱动，重塑产业价值</h2>
                </div>

                <div class="km-card m-about-media">
                    <img src="https://qiniu.shunmingelectronic.com/guanwang/product/huiyi.jpg" alt="舜铭团队" />
                </div>
                <p class="m-about-text">
                    河南舜铭电子信息科技有限公司是一家新成立的科技型企业，位于河南省洛阳市高新区。我们的团队专注于电子信息和物联网领域的研发，致力于为客户提供全面的智能化与信息化解决方案，包括物联网平台、仪器仪表PCB、智能传感器、物联网设备、人工智能和边缘计算等服务。并以精益求精、合作共赢为理念，联合传统行业的同仁，实现优势互补，达到 1+1 大于 2 的效果。
                </p>

                <div class="km-card m-about-media">
                    <img src="https://qiniu.shunmingelectronic.com/guanwang/platform.jpg" alt="物联网平台" />
                </div>
                <p class="m-about-text">
                    此外，我们还将先进的 4G 技术融入我们的仪器，实现无缝数据传输到物联网平台。这可以实现实时监控和管理，确保我们的客户从增强的连接性和运营效率中受益。
                </p>
            </div>
        </section>

        <section class="m-section m-about-why">
            <div class="km-container">
                <div class="m-head">
                    <span class="km-eyebrow">WHY CHOOSE US</span>
                    <h2 class="m-h2">为什么选择我们</h2>
                </div>
                <div class="m-stack">
                    <article v-for="(item, i) in reasons" :key="i" class="km-card m-why-card">
                        <div class="m-why-card__icon"><img :src="item.icon" :alt="item.title" /></div>
                        <div>
                            <h3 class="m-h3">{{ item.title }}</h3>
                            <p class="m-why-card__desc">{{ item.desc }}</p>
                        </div>
                    </article>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
export default {
    name: 'MobileAboutView',
    data() {
        return {
            reasons: [
                { icon: require('../../assets/chuanx.png'), title: '创新', desc: '不断创新，将 4G 技术融入仪器中，实现与物联网平台的无缝连接并提供智能解决方案。' },
                { icon: require('../../assets/zhuanye.png'), title: '专业', desc: '在流量计的研究和生产方面拥有多年经验，可提供高质量的产品和解决方案。' },
                { icon: require('../../assets/fuwu.png'), title: '优质服务', desc: '不仅提供产品，还提供全面的技术支持和售后服务，确保为客户提供无忧的体验。' },
                { icon: require('../../assets/kehu.png'), title: '以客户为中心', desc: '优先考虑客户需求，提供定制解决方案以帮助实现更高的运营效率。' }
            ]
        }
    }
}
</script>

<style scoped>
.m-about {
    background: var(--bg);
}

.m-about-hero {
    position: relative;
    min-height: 280px;
    display: flex;
    align-items: flex-end;
    overflow: hidden;
}

.m-about-hero__bg {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.m-about-hero__overlay {
    position: absolute;
    inset: 0;
    background: linear-gradient(180deg, rgba(0, 0, 0, 0.4) 0%, rgba(0, 0, 0, 0.7) 70%, var(--bg) 100%);
}

.m-about-hero__content {
    position: relative;
    z-index: 1;
    padding: 0 20px 32px;
    display: flex;
    flex-direction: column;
    gap: 14px;
}

.m-about-hero__title {
    font-family: var(--font-display);
    font-size: 36px;
    font-weight: 700;
    margin: 0;
    color: #fff;
}

.m-about-hero__content .km-eyebrow {
    color: #fff;
    border-color: rgba(255, 255, 255, 0.4);
    background: rgba(255, 255, 255, 0.10);
}

.m-section {
    padding: 56px 0;
}

.m-head {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: 16px;
    margin-bottom: 32px;
}

.m-h2 {
    font-family: var(--font-display);
    font-size: 26px;
    line-height: 1.2;
    letter-spacing: -0.02em;
    font-weight: 700;
    margin: 0;
}

.m-h3 {
    font-family: var(--font-display);
    font-size: 18px;
    font-weight: 600;
    margin: 0 0 8px;
}

.m-about-media {
    overflow: hidden;
    padding: 0;
    margin-bottom: 18px;
}

.m-about-media img {
    width: 100%;
    display: block;
}

.m-about-text {
    color: var(--text-soft);
    font-size: 15px;
    line-height: 1.8;
    text-align: left;
    margin: 0 0 36px;
}

.m-stack {
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.m-why-card {
    display: flex;
    align-items: flex-start;
    gap: 18px;
    padding: 24px 22px;
    text-align: left;
}

.m-why-card__icon {
    flex-shrink: 0;
    width: 60px;
    height: 60px;
    border-radius: 14px;
    background: var(--accent-soft);
    border: 1px solid var(--border);
    display: flex;
    align-items: center;
    justify-content: center;
}

.m-why-card__icon img {
    width: 36px;
    height: 36px;
    object-fit: contain;
}

.m-why-card__desc {
    color: var(--text-soft);
    font-size: 14px;
    line-height: 1.65;
    margin: 0;
}
</style>
